<template lang="pug">
  .carousel-arrows
    .prev(@click="$emit('prev')")
      Icon(name="arr-back" pointer)
    .next(@click="$emit('next')")
      Icon(name="arr-back" pointer)
</template>

<script>
export default {
  name: 'CarouselArrows',
};
</script>

<style scoped>

  .carousel-arrows {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .prev, .next {
    width: 26px;
    height: 26px;
    background: #EBEFF2;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .next svg {
    transform: rotate(180deg);
  }
</style>
